<template>
  <svg class="svg-inline--fa fa-w-16" viewBox="0 0 16 16" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 16 16"><path d="M0 10h4v6H0zM6 6h4v10H6zM12 0h4v16h-4z" fill="currentColor" class="fill-000000"></path></svg>
</template>